import React from 'react';
import PropTypes from 'prop-types';

import CART_ITEM from '../../constants/cartItems';
import Avatar from '../../../../components/global/Avatar';
import { getIdentityName } from '../../../../util/identity';
import ContextualString from '../../../../components/contextual/ContextualString';
import { getAlbumSubscriptionCartItemPrice } from '../../redux/helpers';
import TrashIcon from '../../../../components/icons/TrashIcon';
import { getAsset } from '../../../../util/assets';
import CheckoutCartItemPriceDisplay from './CheckoutCartItemPriceDisplay';
import CartItemVendor from './CartItemVendor';
import FreePassPromoCodeLabel from '../../../../components/global/FreePassPromoCodeLabel';
import { getEnforcePricingTagDigitalDownloads } from '../../../../apps/pro/views/HierarchyItem/Matches/components/PurchasingOptions/helpers';

const propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf([CART_ITEM.ALBUM_SUBSCRIPTION]).isRequired,
    album: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      enforce_pricing_tag_digital_downloads: PropTypes.bool,
    }).isRequired,
    identity: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  pricing: PropTypes.shape({
    price: PropTypes.object,
    discount_price: PropTypes.object,
  }),
  loading: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  freePassPromoCode: PropTypes.string,
};

const AlbumSubscriptionCartItem = ({
  item,
  pricing,
  loading,
  onRemove,
  // The free pass code applied to the cart, explained on hover.
  freePassPromoCode,
}) => {
  const { album, identity } = item;
  const price = getAlbumSubscriptionCartItemPrice(item);
  const identityName = getIdentityName(identity);
  const excludesTeamPhotos = getEnforcePricingTagDigitalDownloads(
    undefined,
    album,
  );

  return (
    <div className="checkout-cart-item checkout-album-folder-subscription-cart-item">
      <div className="checkout-cart-item-content">
        <div className="checkout-cart-item-figure">
          <img src={getAsset('/icon-photo-pass.svg')} alt="" />
          <span className="identity-avatar-container">
            <Avatar
              photo={{
                thumbnail_urls: [
                  {
                    url: getAsset('/user-menu-default.png'),
                    width: 0,
                    height: 0,
                  },
                ],
              }}
              withCheckmark={false}
            />
          </span>
        </div>

        <div className="checkout-cart-item-info">
          <span className="checkout-cart-item-title">
            <ContextualString
              id="purchaseSubscriptionText"
              defaultMessage="Photo Pass"
              type={album.album_type}
              subtype={album.album_subtype}
            />

            <button
              className="checkout-cart-item-btn-remove"
              onClick={() => onRemove(item.id)}
            >
              <TrashIcon color="#fe5851" size={18} />
            </button>
          </span>
          <CheckoutCartItemPriceDisplay
            clientPrice={price}
            pricing={pricing}
            loading={loading}
            freeLabel={
              freePassPromoCode ? (
                <FreePassPromoCodeLabel promoCode={freePassPromoCode} />
              ) : undefined
            }
          />{' '}
          <CartItemVendor cartItem={item} />
          <div className="checkout-cart-item-description">
            {excludesTeamPhotos
              ? 'Includes Hi–Res downloads of'
              : 'Includes all Hi–Res downloads of'}
            <br />
            <b>
              {identityName} in the Album:
              <br />
              {album.name}
            </b>
            {excludesTeamPhotos && (
              <>
                <br />
                Team photos are not included.
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

AlbumSubscriptionCartItem.propTypes = propTypes;

export default AlbumSubscriptionCartItem;
